<template>
	<div class="Footer text-white text-[16px]">
		<div class="bg-[#161E30] pt-[42px] pb-[60px] box-border">
			<div
				class="2xl:max-w-7xl xl:max-w-7xl lg:container md:container mx-auto mb-[28px] pb-[52px] flex justify-between bB-01">
				<div class="flex ">
					<div :class="index+1!=navList.length?'mr-[160px]':''" v-for="(item,index) in navList" :key="index"
						class="">
						<div class="text-[22px] mb-[16px]">{{item.name}}</div>
						<div class="w-[20px] h-[4px] bg-white mb-[28px]">
						</div>
						<div v-for="(itm,ind) in item.children" :key="ind" class="mb-[10px]">
							{{itm.name}}
						</div>
					</div>
				</div>
				<div class="flex ">
					<div class="mr-[37px]">
						<div class="text-[22px] mb-[16px] w-[150px] text-center">{{langInfo.APP_download}}</div>
						<img :src="download_app_image" class="w-[150px] h-[150px]" alt="" />
					</div>
					<div class="mr-[37px]">
						<div class="text-[22px] mb-[16px] w-[150px] text-center">{{langInfo.official_wechat}}</div>
						<img :src="official_weChat" class="w-[150px] h-[150px]" alt="" />
					</div>
				</div>

			</div>
			<div class=" 2xl:max-w-7xl xl:max-w-7xl lg:container md:container mx-auto">
				<div class="mb-[10px]">
					{{langInfo.friendship_link}}：
				</div>
				<div @click="viewList(item,index)" v-for="(item,index) in linkList" :key="index"
					class="signTitle cursor-pointer pl-[19px] box-border relative mb-[10px]">
					{{item.link_name}}
				</div>
			</div>
		</div>
		<div class="bg-[#313131] h-[46px]   leading-[46px] flex items-center justify-center">
			<!-- <label class="cursor-pointer" @click="goRecord()">{{record_number}}</label> -->
			<img src="@/static/image/icon09.png"class="mr-[4px] w-[24px] h-[24px]" alt="" />
			<label class="cursor-pointer" @click="goRecord()">{{record_number}}</label>
			<label v-if="copyright">｜{{copyright}}</label>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				linkList: [],
				navList: [],
				langInfo: {},
				official_weChat: '',
				download_app_image: '',
				record_number: '',
				copyright: ''

			}
		},
		mounted() {
			this.getdict_data()
			this.get_link_list()
			this.get_nav_list()
			this.getconfig()
		},
		methods: {
			getconfig() {
				// official_weChat=首页官方微信
				// download_app_image=下载二维码
				this.$api.config({}).then((res) => {
					console.log(res);
					this.official_weChat = res.data.official_weChat
					this.download_app_image = res.data.download_app_image
					this.copyright = res.data.copyright
					this.record_number = res.data.record_number


				}).catch((error) => {})
			},
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj
					this.rules.desc[0].message = this.langInfo.phone_content_tip
				}).catch((error) => {})
			},
			get_link_list() {
				this.$api.linkList({}).then((res) => {
					console.log("友情链接列表");
					console.log(res);
					this.linkList = res.data
				}).catch((error) => {})
			},
			viewList(item, index) {
				window.open(item.link_url, '_blank')
			},
			get_nav_list() {
				this.$api.navList({}).then((res) => {
					
					this.navList = res.data
				}).catch((error) => {})
			},
			goRecord() {
				const url = `https://beian.miit.gov.cn/`;
				window.open(url, "_blank");
			}
		}
	}
</script>

<style>
	.Footer .signTitle::after {
		content: '';
		position: absolute;
		width: 10px;
		height: 10px;
		background-color: #1684FC;
		border-radius: 50%;
		top: 50%;
		left: 0;
		transform: translateY(-50%);
		z-index: 1;
	}
</style>